export const loadData = (params, search) => (dispatch, getState) => {
  return Promise.resolve();
};
